export default __webpack_public_path__ + "static/media/cone.f069d66e.svg";